import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const accessGrantsPage = PageBlueprint.make({
  name: 'access-grants',
  params: {
    path: '/bitbucket/access-grants',
    loader: async () => {
      const { AccessGrantsPage } = await import(
        './components/AccessGrantsPage'
      );
      return <AccessGrantsPage />;
    },
  },
});

/**
 * The dashboard of temporary push exemptions: every grant requested through
 * the push access template, where it is between its pull request and the
 * proof it ended, and the history of each.
 */
export const bitbucketManagementPlugin = createFrontendPlugin({
  pluginId: 'bitbucket-management',
  extensions: [accessGrantsPage],
});
